__turbopack_context__.v({
  "app_light_theme": "SquareCatBlock-module-scss-module__sFjVZW__app_light_theme",
  "imageWrap": "SquareCatBlock-module-scss-module__sFjVZW__imageWrap",
  "item": "SquareCatBlock-module-scss-module__sFjVZW__item",
  "itemTitle": "SquareCatBlock-module-scss-module__sFjVZW__itemTitle",
  "link": "SquareCatBlock-module-scss-module__sFjVZW__link",
  "list": "SquareCatBlock-module-scss-module__sFjVZW__list",
  "squareCatBlock": "SquareCatBlock-module-scss-module__sFjVZW__squareCatBlock",
  "title": "SquareCatBlock-module-scss-module__sFjVZW__title",
});
